import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-badge.css';
import { UitkBadgeSize, UitkBadgeStandardThemes } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkBadgeStandard = function (props) {
  var _a, _b;
  var text = props.text,
    size = props.size,
    theme = props.theme,
    a11yText = props.a11yText,
    className = props.className,
    children = props.children;
  var sharedCssClassName = 'uitk-badge-base';
  var baseCssClassName = 'uitk-badge';
  var hasTextAsChild = React.Children.toArray(children).some(function (child) {
    return typeof child === 'string';
  });
  var standardBadgeClassNames = getClassNameList(baseCssClassName, "".concat(sharedCssClassName, "-").concat(validatePropType(size, UitkBadgeSize) ? size : UitkBadgeSize.LARGE), (_a = {}, _a["".concat(sharedCssClassName, "-has-text")] = text, _a), (_b = {}, _b["".concat(sharedCssClassName, "-icon-only")] = !text && children && !hasTextAsChild, _b), "".concat(baseCssClassName, "-").concat(validatePropType(theme, UitkBadgeStandardThemes) ? theme : UitkBadgeStandardThemes.STANDARD), className);
  return React.createElement("span", {
    className: standardBadgeClassNames
  }, children, text && React.createElement("span", {
    className: getClassNameList("".concat(sharedCssClassName, "-text")),
    "aria-hidden": !!a11yText
  }, text), a11yText && React.createElement("span", {
    className: getClassNameList('is-visually-hidden')
  }, a11yText));
};
UitkBadgeStandard.displayName = 'UitkBadgeStandard';
export { UitkBadgeStandard };